import { Colors, RadioInput } from "swing-components";

import type { RadioAnswerType } from "~onboarding/utils";

type RadioAnswerProps = Omit<RadioAnswerType, "type"> & {
  /**
   * The value of the answer. This is undefined when there is no answer.
   */
  value?: string;
  /**
   * When answering the Question, pass the `value` to the parent.
   */
  onChange: (value: string) => void;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

export function RadioAnswer(props: RadioAnswerProps) {
  const { value, onChange, isReadOnly, options } = props;

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {options.map((option, index) => {
        const isLast = index === options.length - 1;

        return (
          <div key={option.value}>
            <div>
              <RadioInput
                status={isReadOnly ? "disabled" : "enabled"}
                isSelected={value === option.value}
                onChange={onChange}
                label={option.label}
                value={option.value}
                description={option.description}
                hasContainer={option.hasContainer}
              />

              {/* when isCorrect is defined AND this option is selected show correct text */}
              {option.isCorrect === true && value === option.value && (
                <span
                  css={{
                    transform: "translate(calc(20px + 16px), 0px)",
                    display: "inline-block",
                    fontSize: 12,
                    color: Colors.green500,
                  }}
                >
                  Correct!
                </span>
              )}
              {/* when isCorrect is defined AND this option is NOT selected show incorrect text */}
              {option.isCorrect === false && value === option.value && (
                <span
                  css={{
                    transform: "translate(calc(20px + 16px), 0px)",
                    display: "inline-block",
                    fontSize: 12,
                    color: Colors.red500,
                  }}
                >
                  That's not right, try again!
                </span>
              )}
            </div>

            {/*
              Divider
              Only render when there is no container around the radio option.
            */}
            {!option.hasContainer && !isLast && (
              <hr
                css={{
                  height: 1,
                  backgroundColor: Colors.slate200,
                  border: "none",
                  // NOTE: Using negative margins to offset the padding between
                  // items due to having this divider.
                  marginTop: -8,
                  marginBottom: -8,
                  marginLeft: 0,
                  marginRight: 0,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
